import { render, staticRenderFns } from "./refuseReason.vue?vue&type=template&id=0539e51a&scoped=true&"
import script from "./refuseReason.vue?vue&type=script&lang=js&"
export * from "./refuseReason.vue?vue&type=script&lang=js&"
import style0 from "./refuseReason.vue?vue&type=style&index=0&id=0539e51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539e51a",
  null
  
)

export default component.exports